<template>
</template>
  
  <script>
    export default {
      name: 'Inicio'
    }
  </script>